import * as http from 'axios'

export const getTipoUnidades = (q) => http.get(`/redeUnidades?sort=name&name__regex=/.*${q}.*/i`)



// WEBPACK FOOTER //
// ./src/store/redeUnidade/services.js